import { EComponent } from '../models/base';
import { ICategory } from '../models/category.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getAll(component?: EComponent) {
  return request<ICategory[]>({
    url: '/public/category',
    params: {
      lang: 'en',
      component,
    },
    method: 'GET',
  });
}

function listing(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
    component?: EComponent;
  },
) {
  return request<IPaginationData<ICategory>>({
    url: '/category/listing',
    params: query,
    method: 'GET',
  });
}

function getDetail(id: string) {
  return request<ICategory>({
    url: `/category/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<ICategory>) {
  return request<ICategory>({
    url: `/category`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<ICategory>) {
  return request<ICategory>({
    url: `/category/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<ICategory>({
    url: `/category/${id}`,
    method: 'DELETE',
  });
}

const categoryApi = Object.freeze({
  getAll,
  listing,
  create,
  getDetail,
  remove,
  update,
});

export default categoryApi;
